import { withStyles, createStyles, TableRow } from '@material-ui/core';

const TableRowCustom = withStyles(theme =>
  createStyles({
    root: {
      border: '',
      '&:hover': {
        background: '#F7F9FC'
      },
       '&.Mui-selected': {
        backgroundColor: '#E3F2FD', // warna biru muda sebagai contoh
      },
    }
  })
)(TableRow);

export default TableRowCustom;
